import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { truncate } from "lodash";
import moment from "moment";
import "./import-installed-widget.scss";

import { Divider,Modal, Button } from "antd";
import { TWidget } from "./constants";
import { Http } from "../../../../helpers/axois";
import { GCPENDPOINT } from "../../../../constant/common";
import { generatePluginSchema, attachTypeDefs } from "../../../../helpers/commonFunction"
import { loadPlugins } from "../../../../helpers/MicroFrontend";
import { addWidget, addPackage, updateWidget } from "../../../../stateManager/store/product/actions";
import { unImportFormWidgetProperties, updateFormWidgetProperties } from "../../../../stateManager/store/formCreation/action";
import placeholderImg  from '../../../../assets/images/imagePlaceholder.png';
import { useToast } from '../../../../helpers/commonFunction';
import { logger } from "../../../../constant/winston";
import { ReactComponent as CloseIcon } from "../../../../assets/svg/roundedCloseIcon.svg";
import { PUSH_ACTION_STACK } from "../../../../stateManager/store/formCreation/types";
import { addWidgetId, removeWidgetId } from "../../../../stateManager/store/widgetsID/actions";
import { AppState } from "../../../../stateManager/store";

declare const window: any;

interface IImportInstalledWidget {
  onInstall(): void;
  widgets: TWidget[];
  appId: string;
  formId: string;
  activeTab: string;
}

const getFormatDescription = (value: string, length: number) =>
  truncate(value, { length, separator: " " });

const ImportInstalledWidget: React.FC<IImportInstalledWidget> = (props) => {
  const { formId, appId, activeTab } = props;
  const dispatch = useDispatch();
  const selectedOrgId = useSelector((state: any) => state.org.selectedOrg.id);
  const { ErrorToast, SuccessToast ,WarningToast} = useToast();
  const forms = useSelector((state: any) => state.formcreation);
  const form = forms[formId];
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [wigetname,SetWidgetname]= useState("")
  const [widgetId,SetWidgetId] = useState<any>()
  const handleButtonClick = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  // extract the imported productIds from the store
  const products = useSelector((state: any) => state.product)
  const importedWidgets = (products[formId] && products[formId].widgets) || []
  let importedPackages = (products[formId] && products[formId].packages) || {}
  importedPackages = Object.keys(importedPackages).map((el: any) => importedPackages[el]).flat()
  const importedProductIds = [...importedWidgets, ...importedPackages].map((el: any) => el.json.productId)

  const handleImportWidget = async (widget: any) => {
    if ((!orgPermissions?.includes("app.Import") || !orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View')) && loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    }
    props.onInstall();
    const pluginUrl = widget?.object_url?.startsWith("https://") ? widget.object_url : GCPENDPOINT + widget.object_url;

    await loadPlugins(pluginUrl, widget.id, async () => {
      const { type: pluginType, data: plugin } = window[widget.build_id] // closure in action

      // attach typedefinitions coming from the plugins
      attachTypeDefs(widget.build_id)

      if (pluginType === "Package") {
        const packageWidgets = Object.keys(plugin.widgets).map((el: any) => {
          const packageWidget = plugin.widgets[el]
          return generatePluginSchema(
            el,
            packageWidget.name,
            widget.build_id,
            pluginUrl,
            { widgetName: el, productId: widget.id }
          )
        })
        dispatch(addPackage({
          formId,
          pkg: {
            [widget.name]: packageWidgets
          }
        }))
      } else {
        const newWidget = generatePluginSchema(
          widget.build_id,
          widget.name,
          widget.build_id,
          pluginUrl,
          { productId: widget.id }
        )
        dispatch(addWidget({
          formId,
          widget: newWidget
        }))
      }

      const endpoint = `orgs/${selectedOrgId}/store/products/${widget.id}/import`;
      try {
        // check that widget is exiting or not to avoid another api call
        const checkProductId = `/apps/${appId}/forms/${formId}/store/products`;
        Http.get(checkProductId).subscribe((response: any) => {
          let products = Array.isArray(response) ? response : Object.values(response).find(Array.isArray) || [];
          if (products.map(p => p.store_product_id).includes(widget.id)) {
            dispatch(removeWidgetId(widget.id));
            return null;
          } else {
            return Http.post(endpoint, { appId, formId }).toPromise();
          }
        });
        SuccessToast("Widget import process started");
      } catch(err) {
        if (err === "Forbidden") {
          ErrorToast("Not Authorized: Please request owner of this organization to provide access")
        } else {
        ErrorToast("Failed to import")
      }
        logger.error(err)
      }
    });
  };
  const getModifiedFieldsByProductId: any = ({ fields, productId }: any) => {
    if (!Array.isArray(fields)) return fields;
    return fields.map((item) => {
      if (item.fields && item.fields.length > 0) {
        item.fields = getModifiedFieldsByProductId({
          fields: item.fields,
          productId,
        });
      }
      if (item.productId === productId) {
        return null;
      }
      return item;
    }).filter(item => item !== null);
  };
  
  const changeData = (data: any[], { productId }: { productId: string }) => {
    return data.map((item) => {
      const modifiedFields = getModifiedFieldsByProductId({
        fields: item.fields,
        productId,
      });
      return {
        ...item,
        fields: modifiedFields,
      };
    });
  };
    
  const handleUnImportWidget = async (id: string) => {
    //   const endpoint = `orgs/${selectedOrgId}/store/products/${id}/import`;
    const widgets = (products[formId] && products[formId].widgets) || [];
    const packages = (products[formId] && products[formId].packages) || {};

    const productIds: string[] = [];
    
    const customPackages = Object.values(packages || {}).find(Array.isArray) || [];
    customPackages.forEach((widget: any) => {
      if (widget.json && widget.json.productId) {
        productIds.push(widget.json.productId);
      }
    });

    const uniqueProductIds = Array.from(new Set(productIds));

    const importedOne = { widgets, packages }
    let importedObjects = [];
    importedObjects.push(importedOne);

    const previousWidgetState = widgets.find((widget: any) => widget.json.productId === id);
    const previousPackageStates: any = Object.values(packages)
      .flat()
      .find((pkg: any) => pkg.json.productId === id)
    const extractedProductId = previousPackageStates ? previousPackageStates.json.productId : null;
    
    // fiding packages and and theier widgets(ex:customWigets)
    function findReturnArray(id: any) {
      for (const key in packages) {
        if (Array.isArray(packages[key])) {
          for (const item of packages[key]) {
            if (item.json.productId === id) {
              return { arrayName: key, array: packages[key] };
            }
          }
        }
      }
      return null;
    }
    const result = findReturnArray(extractedProductId);

    // set it as an object for maintaing undo stack
    const previousVal = () => {
      if (result) {
        const arrayName = result.arrayName;
        if (uniqueProductIds.includes(extractedProductId)) {
          const products = {
            [arrayName]: result.array

          };
          return products;
        }
      }
      return null;
    };

    const previousPackageState = previousVal();
    const currentFormState = JSON.parse(JSON.stringify(form));

    dispatch(updateWidget({
      formId,
      id
    }))
    try {
      // Perform the unimport operation
      const result = changeData(form, { productId: id });
      // Dispatch undo and redo actions
      dispatch({
        type: PUSH_ACTION_STACK,
        data: {
          undo: () => {
            // Restore the form state to what it was before unimporting
            dispatch(unImportFormWidgetProperties({
              formid: formId,
              result: currentFormState
            }));
            //Restore the value and Maintaining the tree view products in the undo stack.
            dispatch(updateWidget({
              formId,
              id,
              previousWidgetState,
              previousPackageState
            }))
          },
          redo: () => {
            // Apply the unimport operation again
            dispatch(unImportFormWidgetProperties({
              formid: formId,
              result
            }));
            //Apply the value and Maintaining the tree view products in the redo stack.
            dispatch(updateWidget({
              formId,
              id,
            }))
          },
        },
      });
      setIsModalVisible(false);
      WarningToast("Widget unimported, Remember to save the form.");
      dispatch(addWidgetId(id));
    } catch (err) {
      logger.error(err);
      ErrorToast("Failed to Unimport");
    }
  };

  return (
    <div>
      <div className="widget-import-card grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 widget-container">
        {props.widgets.map((widget) => (
          <div
            key={widget.id}
            className="widget-card h-fit"
          >
            <div className="icon-info">
              <img src={widget.preview_image ? `${(widget?.preview_image || '').startsWith("https://") ? widget.preview_image : GCPENDPOINT + widget.preview_image}` : placeholderImg} alt="icon" />
              <div className="info max-w-70%">
                <h4 className="hl truncate text-ellipsis w-95% text-title-size">{widget.name}</h4>
                <p className="truncate whitespace-pre-wrap overflow-hidden break-words">{getFormatDescription(widget.description, 77)}</p>
              </div>
            </div>

            <div className="author-install">
              <p>
                By:{" "}
                <span className="hl">
                  {widget.first_name} {widget.last_name}
                </span>
              </p>

              {activeTab === "Installed Widgets" && !importedProductIds.includes(widget.id) && <button
                data-test-id="import"
                onClick={() => handleImportWidget(widget)}
                className={`${widget.is_installed ? "btn-installed" : "btn-install"
                  }`}
              >
                Import
              </button>}
              <>
                {activeTab === "Installed Widgets" && importedProductIds.includes(widget.id) && (
                  <button
                    data-test-id="unimport"
                    onClick={() => {
                      handleButtonClick()
                      SetWidgetId(widget.id);
                      SetWidgetname(widget.name)
                    }}
                    className={widget.is_installed ? "btn-installed" : "btn-install"}
                  >
                    Unimport
                  </button>
                )}
                <Modal
                  title="REMOVE"
                  visible={isModalVisible}
                  className="override-modal"
                  style={{
                    top: 200
                  }}
                  width="450px"
                  closeIcon={
                    <CloseIcon
                      data-test-id="close_icon"
                      height="18px"
                      width="18px"
                      onClick={() => {
                        handleCancel()
                      }}
                    />
                  }
                  maskStyle={{
                    background: "#0000001",
                  }}
                  footer={false}
                >
                  <div className="delete-modal delete-modal-content">
                    <p>
                      Are you sure you want to delete the Marketplace function and all references for <span>{wigetname}?</span>
                      <br/>
                      <span>Remember to save the form.</span>
                    </p>
                  </div>
                  <div className="delete-modal delete-modal-footer">
                    <Button data-test-id="cancel" type="ghost" className="cancel" onClick={() => {
                     handleCancel()
                    }}>
                      Maybe next time
                    </Button>
                    <Button data-test-id="ok" type="danger" className="ok" onClick={() => handleUnImportWidget(widgetId)}>
                      Yes, Do it
                    </Button>
                  </div>
                </Modal>
              </>
            </div>

            <Divider style={{ margin: "7px 0" }} />

            <div className="meta-info">
              <p className={`type ${widget.is_paid ? "paid" : ""}`}>
                {widget.is_paid ? "Paid" : "Free"}
              </p>
              <div className="version-updated">
                <p>
                  Version: <span className="hl">{widget.version_tag}</span>
                </p>
                <p className="m-0">
                  Last updated:{" "}
                  <span className="hl">
                    {moment(widget.updated_at).format("MMM Do YYYY")}
                  </span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImportInstalledWidget;
